import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { toast } from '@/hooks/useToast';

export const useLogout = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const logout = async (redirectTo: string = '/login') => {
    if (isLoggingOut) return; // Prevent multiple logout attempts
    
    setIsLoggingOut(true);
    
    try {
      // Clear all React Query cache first
      await queryClient.clear();
      
      // Clear localStorage
      localStorage.clear();
      
      // Sign out from Supabase
      await signOut();
      
    } catch (error) {
      console.error('Logout error:', error);
      
      // Even if there's an error, clear localStorage and try to navigate to login
      localStorage.clear();
      
      toast({
        title: "Errore durante il logout",
        description: "Si è verificato un errore, ma sei stato disconnesso.",
        variant: "destructive",
      });
    } finally {
      setIsLoggingOut(false);
      navigate(redirectTo, { replace: true });
    }
  };

  return {
    logout,
    isLoggingOut
  };
}; 